import React, { useContext, useEffect, useState } from 'react'
import { Outlet, useNavigate, useSearchParams } from 'react-router-dom'
import { UserContext, UserContextPayload } from '../../../context/userContext';
import { ChatbotContext, ChatbotContextPayload } from '../../../context/chatbotContext';
import { checkForErrorCode, flagAccessNotGranted, flagCookieExpired, flagDataNotFound, getErrorMessage, invalidQueryParameter, isAdmin, isDev } from '../../../utils/constants';
import { blackColor, imgSrcSideNavigationPanelIcon, primaryColor } from '../../../utils/colors';
import IconsColor from '../../utility/iconsColor';
import { Autocomplete, Button, Divider, Grid, IconButton, TextField, useMediaQuery } from '@mui/material';
import styles from "../../../assets/styles/componentStyles/dataconnector.module.scss";
import templateStyles from '../../../assets/styles/componentStyles/template.module.scss'
import GlobalPageHeaderText from '../../utility/globalPageHeaderText';
import globalStyles from "../../../assets/styles/global.module.scss";
import chatbotIcon from "../../../assets/images/chatbot/chatbotProfileAvtar.png"
import { chatbotListInterface } from '../../../models/axiosModel';
import { CalendlyContext, CalendlyContextType } from '../../../context/calendlyIntegrationContext';
import { LeadIntegrationContext, LeadIntegrationContextPayload } from '../../../context/leadIntegrationContext';
import AddIcon from '@mui/icons-material/Add';
import { GenericDataContext, GenericDataContextPayload } from '../../../context/genericDataContext';
import { useGenericStore } from '../../../store/genericStore';
import { useShallow } from 'zustand/react/shallow';

const ChatbotDetails = () => {
    const { setFlagLoading, userDetail, setSidePanelMenuItems, flagLoading, handleError } = useContext(UserContext) as UserContextPayload;
    const { GetChatbotDataApi, chatBotDetails, setChatBotDetails, GetChatbotListApi, setChatbotList, chatbotList } = useContext(ChatbotContext) as ChatbotContextPayload
    const { AddNewLeadGeneration, leadGenerationList } = useContext(LeadIntegrationContext) as LeadIntegrationContextPayload
    const { resetChatbotCalendlyData } = useContext(CalendlyContext) as CalendlyContextType
    const { getGptModelList, getAILLMPlatformApi } = useContext(GenericDataContext) as GenericDataContextPayload

    const { showError } = useGenericStore(useShallow((state) => ({
        showError: state.showError
    })))

    const [searchParams] = useSearchParams()
    let chatbot_id = searchParams.get("chatbot_id");
    let pathname = window.location.pathname.toLowerCase();
    const [flagShowValue, setFlagShowValue] = useState(false);
    const smallScreen = useMediaQuery('(max-width : 600px) and (min-width : 0px)')
    const editableSubMenuItems = [
        {
            menuName: chatBotDetails?.chatbot_name,
            menuKey: "none",
            flagHeaderKey: true,
            navigationLink: `/chatbot/viewchatbot/basicdetail?chatbot_id=${chatbot_id}`,
            imgSrc: <img alt="logo" src={`${chatBotDetails?.chatbot_logo_url ? chatBotDetails?.chatbot_logo_url : chatbotIcon}`} height={chatBotDetails?.chatbot_logo_url ? "24" : "26"} width={chatBotDetails?.chatbot_logo_url ? "24" : "26"} style={{ borderRadius: "50%" }} />,
            whiteImgSrc: <img alt="logo" src={`${chatBotDetails?.chatbot_logo_url ? chatBotDetails?.chatbot_logo_url : chatbotIcon}`} height={chatBotDetails?.chatbot_logo_url ? "24" : "26"} width={chatBotDetails?.chatbot_logo_url ? "24" : "26"} style={{ borderRadius: "50%" }} />,
            coloredImgSrc: <img alt="logo" src={`${chatBotDetails?.chatbot_logo_url ? chatBotDetails?.chatbot_logo_url : chatbotIcon}`} height={chatBotDetails?.chatbot_logo_url ? "24" : "26"} width={chatBotDetails?.chatbot_logo_url ? "24" : "26"} style={{ borderRadius: "50%" }} />,
        },
        {
            menuName: "Basic Details",
            menuKey: "basic_details",
            navigationLink: `/chatbot/viewchatbot/basicdetail?chatbot_id=${chatbot_id}`,
            imgSrc: <IconsColor fillColor={imgSrcSideNavigationPanelIcon} iconName="basicdetail" />,
            whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="basicdetail" />,
            coloredImgSrc: <IconsColor fillColor={blackColor} iconName="basicdetail" />,
        },
        {
            menuName: "Channels",
            menuKey: "channels",
            navigationLink: "/chatbot/viewchatbot/channels",
            imgSrc: <IconsColor fillColor={imgSrcSideNavigationPanelIcon} iconName="channel" />,
            whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="channel" />,
            coloredImgSrc: <IconsColor fillColor={blackColor} iconName="channel" />,
            subMenu: [
                {
                    menuName: "WhatsApp",
                    menuKey: "whatsapp",
                    navigationLink: `/chatbot/viewchatbot/channels/whatsapp?chatbot_id=${chatbot_id}`,
                    imgSrc: <IconsColor fillColor={imgSrcSideNavigationPanelIcon} iconName="whatsappDataConnector" height={"16"} width={"16"} />,
                    whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="whatsappDataConnector" height={"16"} width={"16"} />,
                    coloredImgSrc: <IconsColor fillColor={blackColor} iconName="whatsappDataConnector" height={"16"} width={"16"} />,
                },
                {
                    menuName: "FB Messenger",
                    menuKey: "facebook",
                    navigationLink: `/chatbot/viewchatbot/channels/facebook?chatbot_id=${chatbot_id}`,
                    imgSrc: <IconsColor fillColor={imgSrcSideNavigationPanelIcon} iconName="facebookDataConnector" height={"16"} width={"16"} />,
                    whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="facebookDataConnector" height={"16"} width={"16"} />,
                    coloredImgSrc: <IconsColor fillColor={blackColor} iconName="facebookDataConnector" height={"16"} width={"16"} />,
                },
                {
                    menuName: "Instagram",
                    menuKey: "instagram",
                    navigationLink: `/chatbot/viewchatbot/channels/instagram?chatbot_id=${chatbot_id}`,
                    imgSrc: <IconsColor fillColor={imgSrcSideNavigationPanelIcon} iconName="instagramDataConnector" height={"16"} width={"16"} />,
                    whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="instagramDataConnector" height={"16"} width={"16"} />,
                    coloredImgSrc: <IconsColor fillColor={blackColor} iconName="instagramDataConnector" height={"16"} width={"16"} />,
                },
                {
                    menuName: "Website",
                    menuKey: "website",
                    navigationLink: `/chatbot/viewchatbot/channels/website?chatbot_id=${chatbot_id}`,
                    imgSrc: <IconsColor fillColor={imgSrcSideNavigationPanelIcon} iconName="websiteDataConnector" height={"16"} width={"16"} />,
                    whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="websiteDataConnector" height={"16"} width={"16"} />,
                    coloredImgSrc: <IconsColor fillColor={blackColor} iconName="websiteDataConnector" height={"16"} width={"16"} />,
                },
                // {
                //     menuName: "Calendly",
                //     menuKey: "calendly",
                //     navigationLink: `/chatbot/viewchatbot/channels/calendly?chatbot_id=${chatbot_id}`,
                //     imgSrc: <IconsColor fillColor={imgSrcSideNavigationPanelIcon} iconName="calender" height={"16"} width={"16"} />,
                //     whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="calender" height={"16"} width={"16"} />,
                //     coloredImgSrc: <IconsColor fillColor={blackColor} iconName="calender" height={"16"} width={"16"} />,
                // },
                {
                    menuName: "Slack",
                    menuKey: "slack",
                    navigationLink: `/chatbot/viewchatbot/channels/slack?chatbot_id=${chatbot_id}`,
                    imgSrc: <IconsColor fillColor={imgSrcSideNavigationPanelIcon} iconName="slack" height={"16"} width={"16"} />,
                    whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="slack" height={"16"} width={"16"} />,
                    coloredImgSrc: <IconsColor fillColor={blackColor} iconName="slack" height={"16"} width={"16"} />,
                },
                // {
                //     menuName: "Zoho",
                //     menuKey: "zoho",
                //     navigationLink: `/chatbot/viewchatbot/channels/zoho?chatbot_id=${chatbot_id}`,
                //     imgSrc: <IconsColor fillColor={imgSrcSideNavigationPanelIcon} iconName="zohoIcon" height={"16"} width={"16"} />,
                //     whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="zohoIcon" height={"16"} width={"16"} />,
                //     coloredImgSrc: <IconsColor fillColor={blackColor} iconName="zohoIcon" height={"16"} width={"16"} />,
                // },
            ]
        },
        {
            menuName: "Integrations",
            menuKey: "data_connector",
            navigationLink: `/chatbot/viewchatbot/integration?chatbot_id=${chatbot_id}`,
            imgSrc: <IconsColor fillColor={imgSrcSideNavigationPanelIcon} iconName="dataconnector" />,
            whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="dataconnector" />,
            coloredImgSrc: <IconsColor fillColor={blackColor} iconName="dataconnector" />,
        },
        {
            menuName: "Sub AI Chatbots",
            menuKey: "sub_ai_chatbot",
            navigationLink: `/chatbot/viewchatbot/subaichatbot?chatbot_id=${chatbot_id}`,
            imgSrc: <IconsColor fillColor={imgSrcSideNavigationPanelIcon} iconName="subChatbotIcon" height={"24"} width={"24"} />,
            whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="subChatbotIcon" height={"24"} width={"24"} />,
            coloredImgSrc: <IconsColor fillColor={blackColor} iconName="subChatbotIcon" height={"24"} width={"24"} />,
        },
        {
            menuName: "Persistent Menu",
            menuKey: "persistent_menu",
            navigationLink: `/chatbot/viewchatbot/persistentmenu?chatbot_id=${chatbot_id}`,
            imgSrc: <IconsColor fillColor={imgSrcSideNavigationPanelIcon} iconName="persistentmenu" />,
            whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="persistentmenu" />,
            coloredImgSrc: <IconsColor fillColor={blackColor} iconName="persistentmenu" />,
        },
        {
            menuName: "Try Chatbot",
            menuKey: "try_chatbot",
            navigationLink: `/chatbot/viewchatbot/trychatbot?chatbot_id=${chatbot_id}`,
            imgSrc: <IconsColor fillColor={imgSrcSideNavigationPanelIcon} iconName="chatbot" />,
            whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="chatbot" />,
            coloredImgSrc: <IconsColor fillColor={blackColor} iconName="chatbot" />,
        },
        // {
        //     menuName: "Inbox",
        //     menuKey: "inbox",
        //     navigationLink: `/chatbot/viewchatbot/inbox?chatbot_id=${chatbot_id}`,
        //     imgSrc: <IconsColor fillColor={imgSrcSideNavigationPanelIcon} iconName="chat" />,
        //     whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="chat" />,
        //     coloredImgSrc: <IconsColor fillColor={blackColor} iconName="chat" />,
        // },
        {
            menuName: "Lead Generation",
            menuKey: "leadgeneration",
            navigationLink: `/chatbot/viewchatbot/leadgeneration?chatbot_id=${chatbot_id}`,
            imgSrc: <IconsColor fillColor={imgSrcSideNavigationPanelIcon} iconName="leadGeneration" height={"24"} width={"24"} />,
            whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="leadGeneration" height={"24"} width={"24"} />,
            coloredImgSrc: <IconsColor fillColor={blackColor} iconName="leadGeneration" height={"24"} width={"24"} />,
        },
    ];

    const dynamicDataListMenu = {
        menuName: "Products",
        menuKey: "products",
        navigationLink: `/chatbot/viewchatbot/products?chatbot_id=${chatbot_id}`,
        imgSrc: <IconsColor fillColor={imgSrcSideNavigationPanelIcon} iconName="products" height={"24"} width={"24"} />,
        whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="products" height={"24"} width={"24"} />,
        coloredImgSrc: <IconsColor fillColor={blackColor} iconName="products" height={"24"} width={"24"} />,
    }

    const messageFormatMenu = {
        menuName: "UI Components",
        menuKey: "message_format",
        navigationLink: `/chatbot/viewchatbot/messageformat?chatbot_id=${chatbot_id}`,
        imgSrc: <IconsColor fillColor={imgSrcSideNavigationPanelIcon} iconName="chats" />,
        whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="chats" />,
        coloredImgSrc: <IconsColor fillColor={blackColor} iconName="chats" />,
        flagAdmin: true
    }

    const viewSubMenuItems = [
        {
            menuName: chatBotDetails?.chatbot_name,
            menuKey: "none",
            flagHeaderKey: true,
            navigationLink: `/chatbot/viewchatbot/basicdetail?chatbot_id=${chatbot_id}`,
            imgSrc: <img src={`${chatBotDetails?.chatbot_logo_url ? chatBotDetails?.chatbot_logo_url : chatbotIcon}`} height={chatBotDetails?.chatbot_logo_url ? "24" : "26"} width={chatBotDetails?.chatbot_logo_url ? "24" : "26"} style={{ borderRadius: "50%" }} />,
            whiteImgSrc: <img src={`${chatBotDetails?.chatbot_logo_url ? chatBotDetails?.chatbot_logo_url : chatbotIcon}`} height={chatBotDetails?.chatbot_logo_url ? "24" : "26"} width={chatBotDetails?.chatbot_logo_url ? "24" : "26"} style={{ borderRadius: "50%" }} />,
            coloredImgSrc: <img src={`${chatBotDetails?.chatbot_logo_url ? chatBotDetails?.chatbot_logo_url : chatbotIcon}`} height={chatBotDetails?.chatbot_logo_url ? "24" : "26"} width={chatBotDetails?.chatbot_logo_url ? "24" : "26"} style={{ borderRadius: "50%" }} />,
        },
        {
            menuName: "Basic Details",
            menuKey: "basic_details",
            navigationLink: `/chatbot/viewchatbot/basicdetail?chatbot_id=${chatbot_id}`,
            imgSrc: <IconsColor fillColor={imgSrcSideNavigationPanelIcon} iconName="basicdetail" />,
            whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="basicdetail" />,
            coloredImgSrc: <IconsColor fillColor={blackColor} iconName="basicdetail" />,
        },
        {
            menuName: "Channels",
            menuKey: "channels",
            navigationLink: "/chatbot/viewchatbot/channels",
            imgSrc: <IconsColor fillColor={imgSrcSideNavigationPanelIcon} iconName="channel" />,
            whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="channel" />,
            coloredImgSrc: <IconsColor fillColor={blackColor} iconName="channel" />,
            subMenu: [
                {
                    menuName: "Website",
                    menuKey: "website",
                    navigationLink: `/chatbot/viewchatbot/channels/website?chatbot_id=${chatbot_id}`,
                    imgSrc: <IconsColor fillColor={imgSrcSideNavigationPanelIcon} iconName="websiteDataConnector" height={"16"} width={"16"} />,
                    whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="websiteDataConnector" height={"16"} width={"16"} />,
                    coloredImgSrc: <IconsColor fillColor={blackColor} iconName="websiteDataConnector" height={"16"} width={"16"} />,
                },
            ]
        },
        {
            menuName: "Try Chatbot",
            menuKey: "try_chatbot",
            navigationLink: `/chatbot/viewchatbot/trychatbot?chatbot_id=${chatbot_id}`,
            imgSrc: <IconsColor fillColor={imgSrcSideNavigationPanelIcon} iconName="chatbot" />,
            whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="chatbot" />,
            coloredImgSrc: <IconsColor fillColor={blackColor} iconName="chatbot" />,
        },
    ];
    let navigate = useNavigate();
    useEffect(() => {
        getGptModelList()
        getAILLMPlatformApi()

        // Cleanup function to clear chatbot details state.
        return () => {
            setChatBotDetails(null);
        }
    }, [])
    useEffect(() => {
        setFlagLoading({ ...flagLoading, flagRoundLoader: true });
        let chatbotId = searchParams.get('chatbot_id')
        if (chatbotId) {
            (async () => {
                resetChatbotCalendlyData()
                let chatbotId = Number(chatbot_id)
                const response = await GetChatbotDataApi(chatbotId)
                let chatBotResponse = await GetChatbotListApi();
                if (chatBotResponse?.status) {
                    if (chatBotResponse?.data?.length) {
                        setChatbotList(chatBotResponse.data)
                        setFlagLoading({ ...flagLoading, flagRoundLoader: false });
                        setFlagShowValue(true);
                    }
                    else {
                        setFlagShowValue(true)
                        setFlagLoading({ ...flagLoading, flagRoundLoader: false });
                    }
                } else {
                    handleError(response);
                }
                if (!response.status) {
                    let errorCode = checkForErrorCode(response);
                    if (flagCookieExpired(userDetail, errorCode)) {
                        handleError(response);
                    } else {
                        if (invalidQueryParameter(response) || flagAccessNotGranted(userDetail, errorCode) || flagDataNotFound(userDetail, errorCode)) {
                            navigate("/dashboard/chatbot")
                        } else {
                            showError(getErrorMessage(errorCode, isDev(userDetail), response))
                        }
                    }
                }
            })()
        } else {
            navigate("/dashboard/chatbot")
        }
    }, [chatbot_id])

    const checkAdminOrUser = () => {
        if (chatBotDetails?.flag_dynamic_data) {
            // editableSubMenuItems.push(dynamicDataListMenu) 
            editableSubMenuItems.splice(4, 0, dynamicDataListMenu);
        }
        if (isAdmin(userDetail)) {
            editableSubMenuItems.push(messageFormatMenu)
            // viewSubMenuItems.push(messageFormatMenu);
        }
    }

    useEffect(() => {
        checkAdminOrUser()
        if (chatBotDetails) {
            if (chatBotDetails?.chatbot_flag_edit) {
                setSidePanelMenuItems(editableSubMenuItems)
            } else {
                setSidePanelMenuItems(viewSubMenuItems)
            }
        }

    }, [window.location.pathname, chatBotDetails])

    const handleOptionChange = (e: React.ChangeEvent<{}>, value: chatbotListInterface) => {
        const selectedChatbot: any = chatbotList?.find((chatbot) => chatbot.chatbot_id === value.chatbot_id);
        if (selectedChatbot) {
            navigate(`${pathname}?chatbot_id=${selectedChatbot.chatbot_id}`)
        }
    }

    return (
        <>
            {(pathname !== "/chatbot/viewchatbot/integration/createcustomapi" && pathname !== "/chatbot/viewchatbot/products") &&
                <Grid item xl={12} xs={12} className={`${globalStyles.fullwidth} ${globalStyles.dashboardChildWrapper} ${styles.dataConnectorDashboard}`} >
                    {flagShowValue && <Grid container className={globalStyles.flexAlignmentEnd}  >
                        <Grid item xs={12}>
                            <Grid container xs={12} className={globalStyles.createChatbotContainer}>
                                <Grid item className={`${templateStyles.featuredTilesWrapper} ${globalStyles.fullwidth}`} >
                                    <GlobalPageHeaderText
                                        flagTimezone={pathname === "/chatbot/viewchatbot/inbox" && !smallScreen ? true : false}
                                        actionBlock={
                                            pathname === "/chatbot/viewchatbot/leadgeneration" && leadGenerationList && (leadGenerationList.chatbot_lead_data.length > 0) &&
                                            <Grid item>
                                                <Grid container className={`${globalStyles.globalHeadMainItemRightContainer} ${styles.gapAlignment}`} justifyContent={{ lg: "end" }}>
                                                    <Grid item>
                                                        <Grid container className={globalStyles.createChatbotContainer}>
                                                            <Grid item className={templateStyles.addChatbotBtn}>
                                                                <Button
                                                                    variant='outlined'
                                                                    size='large'
                                                                    sx={{ width: "178px" }}
                                                                    fullWidth
                                                                    startIcon={<IconsColor iconName="plus" fillColor="#fff" width="15px" height="15px" />}
                                                                    className={globalStyles.addDocumentBtn}
                                                                    onClick={() => { navigate(`/chatbot/viewchatbot/leadgeneration/createleadgeneration?chatbot_id=${chatbot_id}`); AddNewLeadGeneration() }}
                                                                >
                                                                    New Lead
                                                                </Button>
                                                            </Grid>
                                                            <IconButton
                                                                className={`${globalStyles.cmpGlobalMobileAddIcon} ${templateStyles.addChatbotIcon}`}
                                                                onClick={() => { navigate(`/chatbot/viewchatbot/leadgeneration/createleadgeneration?chatbot_id=${chatbot_id}`); AddNewLeadGeneration() }}
                                                            >
                                                                <AddIcon style={{ height: "28px", width: 'auto' }} />
                                                            </IconButton>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        }
                                        mainHeadText={
                                            <Grid item xs={9} lg={6}>
                                                <Autocomplete
                                                    disableClearable
                                                    value={chatbotList && chatBotDetails ? chatbotList.find((chatbot) => Number(chatbot.chatbot_id) == chatBotDetails.chatbot_id) : undefined}
                                                    className={`${styles.chatbotTitleSelect} ${globalStyles.globalHeaderFontSize} ${globalStyles.globalHeaderFontWeight}`}
                                                    options={chatbotList ? chatbotList : []}
                                                    getOptionLabel={(option: chatbotListInterface) => option.chatbot_name}
                                                    onChange={(e, value) => handleOptionChange(e, value)}
                                                    renderInput={(params) => <TextField
                                                        {...params} placeholder='Select' />} 
                                                    renderOption={(props, option) => {
                                                        return <li {...props} key={`${option?.chatbot_id}-${option?.chatbot_name}`}>
                                                            {option?.chatbot_name ?? ''}
                                                        </li>
                                                    }}
                                                />

                                            </Grid>
                                        }
                                        flagMainTextOnly
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        {!smallScreen && <Divider className={globalStyles.dividerStyles} style={{ color: "#000" }} />}
                    </Grid>}
                </Grid>
            }

            {flagShowValue && <Outlet />}
        </>
    )
}

export default ChatbotDetails
